<template>
    <div ref="top">
        <div class="success" v-if="success" v-html="success" v-cloak></div>
        <div class="error" v-if="error" v-html="error" v-cloak></div>

        <div v-if="displayUserForms" v-cloak>
            <p class="warning">If you already have an account on <em>asc-es.com</em> please <a :href="routes.login"><strong>log in now</strong></a>. Don't have an account on <em>asc-es.com</em>? <a :href="routes.createUser"><strong>Create an account</strong></a>.</p>
        </div>

        <div v-else-if="displayClaimForm" v-cloak>
            <form action="" @submit.prevent="postClaimForm">
                <div class="columns">
                    <div class="claim-form">
                        <h2 class="claim-header">Submit Your Claim</h2>
                        <div class="select-inline">
                            <label for="claimType">
                                Claim Type <span class="required">*</span>
                                <div class="select state-name">
                                    <select name="fields[claimType]" v-model="formData.claimType" id="claimType" required>
                                        <option :value="opt.value" v-text="opt.label" v-for="opt in claimTypes"></option>
                                    </select>
                                </div>
                            </label>
                            <label for="customerName">
                                Company Name <span class="required">*</span>
                                <input type="text" id="customerName" v-model="formData.customerName" required>
                            </label>
                        </div>

                        <div class="input-inline">
                            <label for="accountNumber">
                                Account Number <span class="required">*</span>
                                <input type="text" id="accountNumber" v-model="formData.accountNumber" required>
                            </label>
                            <label for="totalValueOfReturn">
                                Total Value of Return <span class="required">*</span>
                                <input type="text" id="totalValueOfReturn" v-model="formData.totalValueOfReturn" required>
                            </label>
                        </div>

                        <div class="input-inline">
                            <label for="invoiceNumber">
                                Invoice Number <span class="required">*</span>
                                <input type="text" id="invoiceNumber" v-model="formData.invoiceNumber" required>
                            </label>
                            <label for="orderNumber">
                                Order Number <span class="required">*</span>
                                <input type="text" id="orderNumber" v-model="formData.orderNumber" required>
                            </label>
                        </div>

                        <div class="input-inline">
                            <label for="poNumber">
                                Purchase Order Number <span class="required">*</span>
                                <input type="text" id="poNumber" v-model="formData.poNumber" required>
                            </label>

                            <!-- do not display for Freight -->
                            <label for="deliveryNumber" v-if="!displayFreight" v-cloak>
                                Delivery Number
                                <input type="text" id="deliveryNumber" v-model="formData.deliveryNumber">
                            </label>

                            <!-- display for Freight -->
                            <label for="freightCharge" v-if="displayFreight" v-cloak>
                                Freight Charge <span class="required">*</span>
                                <input type="text" id="freightCharge" v-model="formData.freightCharge" required>
                            </label>
                        </div>

                        <!-- display for Material Return, Shortage, Overage, Pricing, Other  -->
                        <div v-if="displayLineItems" v-cloak>
                            <h3>Line Items</h3>

                            <line-item v-for="item in formData.lineItems"
                                :key="item.index"
                                :item="item"
                                :returnQtyRequired="returnQtyRequired"
                                :returnLabelText="returnLabelText"
                                :displayItemReceived="displayItemReceived"
                                :displayReceived="displayQuantityReceived"
                                :displayReturning="displayQuantityReturning"
                                :displayPricing="displayPricing"
                                v-on:remove-line-item="removeLineItem">
                            </line-item>

                            <div class="">
                                <button @click.prevent="addLineItem" class="submit simple">Add a line item</button>
                            </div>
                        </div>

                        <!-- <code v-text="lineItemString" style="white-space:pre;"></code> -->

                        <div v-if="displayReason" v-cloak>
                            <label for="reason">Reason <span class="required">*</span></label>
                            <textarea id="reason" v-model="formData.reason"></textarea>
                        </div>

                        <div>
                            <label for="comments">Comments</label>
                            <textarea id="comments" v-model="formData.comments"></textarea>
                        </div>

                        <label for="">
                            File Upload <span class="required" v-if="photoRequired" v-cloak>*</span><br>
                            <span class="required" v-if="photoRequired" v-cloak>Requirement:  Photos of returned product must be upload with your claim.</span>
                            <div>
                                <label for="fileUpload" class="file-upload">
                                    Upload Files
                                    <input type="file" id="fileUpload" name="fileUpload" multiple @change="setFileUpload">
                                </label>
                            </div>
                            <ul class="files">
                                <li v-for="file, i in formData.fileUpload">
                                    <span class="file-name" v-text="file.name"></span> <i class="fa fa-trash" @click="removeFile(i)"></i>
                                </li>
                            </ul>
                            <div class="help">Upload an image or PDF file (.jpg, jpeg, .png, .pdf)</div>

                        </label>
                    </div>
                    <hr>
                    <div class="contact-info">
                        <div class="return-contact-info">
                            <h2 class="claim-header">Contact Info</h2>
                            <div class="input-inline">
                                <label for="firstName">
                                    First Name <span class="required">*</span>
                                    <input type="text" id="firstName" v-model="formData.firstName" required>
                                </label>
                            </div>
                            <div class="input-inline">
                                <label for="lastName">
                                    Last Name <span class="required">*</span>
                                    <input type="text" id="lastName" v-model="formData.lastName" required>
                                </label>
                            </div>
                            <div class="input">
                                <label for="email">
                                    Email <span class="required">*</span>
                                    <input type="text" id="email" v-model="formData.email" required>
                                </label>
                                <div class="note" style="margin-bottom:.4rem;">Additional email addresses for contact about this claim</div>
                                <label>
                                    <input type="text" id="email2" name="fields[email2]" v-model="formData.email2">
                                    <input type="text" id="email3" name="fields[email3]" v-model="formData.email3">
                                    <input type="text" id="email4" name="fields[email4]" v-model="formData.email4">
                                </label>
                            </div>
                            <div class="input-inline">
                                <label for="phone">
                                    Phone <span class="required">*</span>
                                    <input type="text" id="phone" v-model="formData.phone" required>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" v-if="processing" disabled>Processing &hellip;</button>
                <button type="submit"v-else>Submit</button>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data(){
            return {
                success: null,
                error: null,
                processing: false,
                formData: {
                    user: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    email2: '',
                    email3: '',
                    email4: '',
                    phone: '',
                    accountNumber: '',
                    claimType: '',
                    customerName: '',
                    invoiceNumber: '',
                    orderNumber: '',
                    poNumber: '',
                    deliveryNumber: '',
                    freightCharge: '',
                    lineItems: [
                        {
                            index:0,
                            lineNumber:'',
                            itemNumber:'',
                            itemReceived: '',
                            quantityReceived:'',
                            quantityReturning:'',
                            priceBilled:'',
                            poPrice:'',
                        }
                    ],
                    reason: '',
                    comments: '',
                    fileUpload: []
                },
                userType: 'new',
                password: null,
            }
        },
        computed: {
            newUser() {
                if (this.user && this.user.id) {
                    return false;
                }
                return this.userType == 'new';
            },
            loginUser() {
                if (this.user && this.user.id) {
                    return false;
                }
                return this.userType != 'new';
            },
            displayUserForms() {
                return !this.displayClaimForm;
            },
            displayClaimForm() {
                return (this.user && this.user.id) ? true : false;
            },
            displayFreight() {
                return this.formData.claimType == 'Freight';
            },
            displayPricing() {
                return this.formData.claimType == 'Pricing';
            },
            displayQuantityReceived() {
                let types = ['Overage', 'Carrier Error', 'Wrong Item Shipped'];

                return types.includes(this.formData.claimType);
            },
            displayQuantityReturning() {
                let types = ['Material Return', 'Carrier Error', 'Shortage', 'Wrong Item Shipped'];

                return types.includes(this.formData.claimType);
            },
            returnQtyRequired() {
                return this.formData.claimType != 'Wrong Item Shipped';
            },
            displayItemReceived() {
                return this.formData.claimType == 'Wrong Item Shipped';
            },
            displayLineItems() {
                let types = ['Material Return', 'Shortage', 'Carrier Error', 'Overage', 'Pricing', 'Wrong Item Shipped', 'Other'];

                return types.includes(this.formData.claimType);
            },
            displayReason() {
                return this.formData.claimType != 'Wrong Item Shipped';
            },
            photoRequired() {
                return this.formData.claimType == 'Material Return';
            },
            returnLabelText() {
                if ('Wrong Item Shipped' == this.formData.claimType) {
                    return 'Qty. Short';
                }
                if ('Shortage' == this.formData.claimType) {
                    return 'Qty. to Credit';
                }

                return 'Qty. Returned';
            },
            lineItemString() {
                if (!this.displayLineItems || !this.lineItemsCompleted) {
                    return '';
                }

                let i = 0;
                let item = null;
                let lineItems = "Line Number | Item Number";
                let temp = null;

                if (this.displayPricing) {
                    lineItems = lineItems + " | Price Billed | PO Price";
                }
                if (this.displayQuantityReceived) {
                    lineItems = lineItems + " | Qty. Received";
                }
                if (this.displayQuantityReturning) {
                    lineItems = lineItems + " | " + this.returnLabelText;
                }
                if (this.displayItemReceived) {
                    lineItems = lineItems + " | Item Received";
                }

                const line = '-';

                lineItems = lineItems + "\n" + line.padEnd(lineItems.length, line);

                for (i = 0; i < this.formData.lineItems.length; i++) {
                    item = this.formData.lineItems[i];

                    if (!item.lineNumber || !item.itemNumber) {
                        continue;
                    }

                    lineItems = lineItems + "\n";
                    lineItems = lineItems + item.lineNumber.padEnd(11, ' ') + " | " + item.itemNumber.padEnd(11, ' ');

                    if (this.displayPricing) {
                        lineItems = lineItems + " | " + item.priceBilled.padEnd(12, ' ') + " | " + item.poPrice.padEnd(8, ' ');
                    }
                    if (this.displayQuantityReceived && item.quantityReceived) {
                        lineItems = lineItems + " | " + item.quantityReceived.padEnd(13, ' ');
                    }
                    if (this.displayQuantityReturning) {
                        temp = (item.quantityReturning) ? item.quantityReturning : ' '; // Can't padEnd a null
                        lineItems = lineItems + " | " + temp.padEnd(this.returnLabelText.length, ' ');
                    }
                    if (this.displayItemReceived && item.itemReceived) {
                        lineItems = lineItems + " | " + item.itemReceived.padEnd(13, ' ');
                    }
                }

                return lineItems;
            },
            lineItemsCompleted() {
                if (!this.displayLineItems) {
                    return true;
                }

                let i = 0;
                let item = null;

                for (i = 0; i < this.formData.lineItems.length; i++) {
                    item = this.formData.lineItems[i];

                    if (!item.lineNumber || !item.itemNumber) {
                        return false;
                    }
                    if (this.displayPricing) {
                        if (!item.priceBilled || !item.poPrice) {
                            return false;
                        }
                    }
                    if (this.displayQuantityReceived) {
                        if (!item.quantityReceived) {
                            return false;
                        }
                    }
                    if (this.displayQuantityReturning) {
                        if (this.returnQtyRequired && !item.quantityReturning) {
                            return false;
                        }
                    }
                    if (this.displayItemReceived) {
                        if (!item.itemReceived) {
                            return false;
                        }
                    }
                }
                return true;
            },
            fileUploadCompleted() {
                if (this.photoRequired && this.formData.fileUpload.length == 0) {
                    return false;
                }

                return true;
            },
        },
        methods: {
            toggleUserType() {
                if (this.userType == 'new') {
                    this.userType = 'existing';
                } else {
                    this.userType = 'new';
                }
            },
            setContactInfo() {
                if (this.user) {
                    this.formData.user = [ this.user.id ];
                    this.formData.firstName = this.user.firstName;
                    this.formData.lastName = this.user.lastName;
                    this.formData.email = this.user.email;
                    this.formData.phone = this.user.phone;
                    this.formData.email2 = null;
                    this.formData.email3 = null;
                    this.formData.email4 = null;
                } else {
                    this.formData.user = null;
                    this.formData.firstName = null;
                    this.formData.lastName = null;
                    this.formData.email = null;
                    this.formData.email2 = null;
                    this.formData.email3 = null;
                    this.formData.email4 = null;
                    this.formData.phone = null;
                }
            },
            addLineItem() {
                let newIndex = 1;
                for (i = 0; i < this.formData.lineItems.length; i++) {
                    newIndex = this.formData.lineItems[i].index +1;
                }
                let item = {
                    index: newIndex,
                    lineNumber: '',
                    itemNumber:'',
                    itemReceived: '',
                    quantityReceived:'',
                    quantityReturning:'',
                    priceBilled:'',
                    poPrice:'',

                }
                this.formData.lineItems.push(item);
            },
            removeLineItem(index)
            {
                let i = 0;
                for (i = 0; i < this.formData.lineItems.length; i++) {
                    if (this.formData.lineItems[i].index == index) {
                        this.formData.lineItems.splice(i, 1);
                    }
                }
            },
            clearMessages() {
                this.error = null;
                this.success = null;
            },
            setMessage(messageType, message) {
                this.error = null;
                this.success = null;

                if ('error' == messageType) {
                    this.error = message;
                }
                if ('success' == messageType) {
                    this.success = message;
                }

                let top = this.$refs['top'].offsetTop;

                window.scrollTo(0, top);
            },
            setErrors(errors) {
                let message = 'Please fix the following errors';
                message = message + '<ul>';
                for (const [key, value] of Object.entries(errors)) {
                    message = message + '<li>' + value + '</li>';
                }
                message = message + '</ul>';

                this.setMessage('error', message);
            },
            resetClaimForm() {
                this.setContactInfo();

                this.formData.accountNumber = '';
                this.formData.customerName = '';
                this.formData.claimType = '';
                this.formData.totalValueOfReturn = '';
                this.formData.invoiceNumber = '';
                this.formData.orderNumber = '';
                this.formData.poNumber = '';
                this.formData.deliveryNumber = '';
                this.formData.freightCharge = '';
                this.formData.lineItems = [
                    {
                        index:0,
                        lineNumber:'',
                        itemNumber:'',
                        itemReceived: '',
                        quantityReceived:'',
                        quantityReturning:'',
                        priceBilled:'',
                        poPrice:'',
                    }
                ];
                this.formData.reason = '';
                this.formData.comments = '';
                this.formData.fileUpload = [];
            },
            validateClaimForm() {
                let errors = {};

                if (!this.formData.firstName) {
                    errors['firstName'] = 'First Name cannot be blank';
                }
                if (!this.formData.lastName) {
                    errors['lastName'] = 'Last Name cannot be blank';
                }
                if (!this.formData.email) {
                    errors['email'] = 'Email cannot be blank';
                }
                if (!this.formData.phone) {
                    errors['phone'] = 'Phone cannot be blank';
                }
                if (!this.formData.accountNumber) {
                    errors['accountNumber'] = 'Account Number cannot be blank';
                }
                if (!this.formData.claimType) {
                    errors['claimType'] = 'Claim Type cannot be blank';
                }
                if (!this.formData.customerName) {
                    errors['customerName'] = 'Company Name cannot be blank';
                }
                if (!this.formData.totalValueOfReturn) {
                    errors['totalValueOfReturn'] = 'Total Value of Return cannot be blank';
                }
                if (!this.formData.invoiceNumber) {
                    errors['invoiceNumber'] = 'Invoice Number cannot be blank';
                }
                if (!this.formData.orderNumber) {
                    errors['orderNumber'] = 'Order Number cannot be blank';
                }
                if (!this.formData.poNumber) {
                    errors['poNumber'] = 'Purchase Order Number cannot be blank';
                }
                if (!this.lineItemsCompleted) {
                    errors['lineItems'] = 'All line items must all be completed';
                }
                if (this.displayFreight && !this.formData.freightCharge) {
                    errors['freightCharge'] = 'Freight Charge cannot be blank';
                }
                if (this.displayReason && !this.formData.reason) {
                    errors['reason'] = 'Reason cannot be blank';
                }
                if (!this.fileUploadCompleted) {
                    errors['fileUpload'] = 'Upload photo(s) of merchandise to be returned';
                }

                let keys = Object.keys(errors);

                if (!keys.length) {
                    return true;
                }

                this.setErrors(errors);

                return false;
            },
            setFileUpload(event) {
                if (event && event.target.files|length) {
                    //this.formData.fileUpload = [];
                    let file = null;
                    for (i = 0; i < event.target.files.length; i++) {
                        file = event.target.files[i];

                        this.formData.fileUpload.push(file);
                    }

                    // Clear stuck form if a photo is required
                    if (this.processing && this.photoRequired) {
                        if (this.validateClaimForm) {
                            // All form fields validated. Reset so the form can be submitted again.
                            this.processing = false;
                            this.clearMessages();
                        }
                    }
                }
            },
            removeFile(index) {
                this.formData.fileUpload.splice(index, 1);
            },
            postClaimForm() {
                if (this.processing) {
                    return null;
                }
                this.processing = true;
                this.clearMessages();

                if (!this.validateClaimForm()) {
                    return false;
                }

                let _self = this;
                let form = new FormData();

                form.append('fields[user][]', this.user.id);
                form.append('fields[firstName]', this.formData.firstName);
                form.append('fields[lastName]', this.formData.lastName);
                form.append('fields[email]', this.formData.email);
                if (this.formData.email2) {
                    form.append('fields[email2]', this.formData.email2);
                }
                if (this.formData.email3) {
                    form.append('fields[email3]', this.formData.email3);
                }
                if (this.formData.email4) {
                    form.append('fields[email4]', this.formData.email4);
                }
                form.append('fields[phone]', this.formData.phone);
                form.append('fields[accountNumber]', this.formData.accountNumber);
                form.append('fields[claimType]', this.formData.claimType);
                form.append('fields[customerName]', this.formData.customerName);
                form.append('fields[totalValueOfReturn]', this.formData.totalValueOfReturn);
                form.append('fields[invoiceNumber]', this.formData.invoiceNumber);
                form.append('fields[orderNumber]', this.formData.orderNumber);
                form.append('fields[poNumber]', this.formData.poNumber);
                form.append('fields[deliveryNumber]', this.formData.deliveryNumber);
                form.append('fields[lineItems]', this.lineItemString);
                form.append('fields[freightCharge]', this.formData.freightCharge);
                form.append('fields[reason]', this.formData.reason);
                form.append('fields[comments]', this.formData.comments);

                if (this.formData.fileUpload.length) {
                    this.formData.fileUpload.forEach(file => {
                        form.append('fields[fileUpload][]', file, file.name);
                    });
                }

                axios.get('/actions/anvil-module/returns/get-rma-number')
                .then(response => {
                    form.append('fields[rmaNumber]', response.data.number);

                    return axios({
                        method: 'post',
                        url: '/actions/anvil-module/returns/save-new-claim',
                        data: form,
                        headers: {
                            //"Content-Type": "application/json",
                            "Content-Type": "multipart/form-data"
                        }
                    }); // using response.data
                })
                .then(response => {
                    if (response.data.success) {
                        _self.resetClaimForm();
                        _self.setMessage('success', 'Your claim has been submitted successfully.');
                    } else {
                        _self.setErrors(response.data.errors);
                    }
                    _self.processing = false;
                })
                .catch(response => {
                    _self.setMessage('error', response.message);
                    _self.processing = false;
                });
            },
        },
        mounted() {
            this.setContactInfo();

            if (this.postErrors.length > 0) {
                this.setErrors(this.postErrors);
            }
        },
        props: ['user', 'claimTypes', 'routes', 'csrfToken', 'postErrors'],
    }
</script>
